import api from '@/api'
import router from '@/router'

// State
const state = {
  data: null
}

// Gettetrs
const getters = {
  data: state => state.data
}

// Actions
const actions = {
  getAppById({ commit, dispatch, state, rootState }, id) {
    console.log(`[BergOS][API] getAppById - Pending: ${id}`)
    return new Promise(resolve => {
      api
        .getAppById(id)
        .then(response => {
          console.log('[BergOS][API] getAppById - Success!')

          if (state.data && state.data.id !== response.data.id) {
            console.log('[BergOS][API] getAppById - New App (reloading)')
            window.BtDevice.reload()
            return
          }

          commit('SET_APP', response.data)

          if (router.currentRoute.name !== 'App') {
            router.push({ name: 'App' })
          }

          commit('device/SET_CONFIG_ERROR', null, { root: true })
        })
        .catch(() => {
          console.error('[BergOS][API] getAppById - Error!')
          setTimeout(() => {
            dispatch('getAppById', id)
          }, 3000)
        })
    })
  }
}

// Mutations
const mutations = {
  SET_APP(state, payload) {
    state.data = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
